export const PROVIDER_CONSTRAINS = {
  name: {
    presence: { message: "Name is required" }
  },
  email: {
    presence: { message: "Email is required" },
    email: { message: "Email is invalid" }
  },

  phone: {
    presence: { message: "Phone is required" },
    numericality: { message: "Phone isn`t a number" },
    length: {
      maximum: 12,
      minimum: 5,
      tooShort: "Minimum is 5 characters",
      tooLong: "Maximum is 12 characters"
    }
  },

  website: {
    // presence: {message: 'Website is required'},
    // url: true
    url: function(value) {
      if (value.length > 0) {
        return true;
      }
      return false;
    }
  },

  facebook_link: {
    url: function(value) {
      if (value.length > 0) {
        return true;
      }
      return false;
    }
  },

  twitter_link: {
    url: function(value) {
      if (value.length > 0) {
        return true;
      }
      return false;
    }
  },

  linkedin_link: {
    url: function(value) {
      if (value.length > 0) {
        return true;
      }
      return false;
    }
  },

  provided_workshops: {
    presence: { message: "Workshop is required" }
  },
  bio: {
    presence: { message: " is required" }
  },
  qualifications: {
    presence: { message: " is required" }
  },
  user_type: {
    presence: { message: "User type is required" }
  }
};

export const TARGET_FILE_MAX_SIZE = 5 * 1024 * 1024;

export const PROVIDER_LOGO_CONTENT_TYPES = [
  "image/jpg",
  "image/jpeg",
  "image/png"
];



// WEBPACK FOOTER //
// ./src/constants/provider_constrains.js